import { useContext, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import TempoBoxCustomizer from 'components/signUpFunnel/box/TempoBoxCustomizer';
import { UserContext } from 'components/signUpFunnel/Contexts';
import { TEMPO } from 'lib/constants';
import { Statuses } from 'lib/constants/signUp';
import { logEvent, events } from 'services/analytics';
import * as ErrorLogging from 'services/ErrorLogging';
import RequestService from 'services/RequestService';

const RecommendationsContainer = ({ setWeeklyMeals, weeklyMeals, setShowBoxOptions }) => {
  const [boxRecommendations, setBoxRecommendations] = useState({});
  const [mealPriceDetails, setMealPriceDetails] = useState(null);

  const { user } = useContext(UserContext);

  useEffect(() => {
    const fetchRecommendedBox = async () => {
      try {
        const response = await RequestService.getRecommendedBox();
        if (response.ok) {
          setWeeklyMeals(
            [Statuses.PICK_MEALS_BILLING_STEP, Statuses.PICK_MEALS_STEP].includes(user.status)
              ? user.weeklyMeals
              : response.recommendedMeals
          );
          setBoxRecommendations({
            recommendedMeals: response.recommendedMeals,
            recommendedServings: response.recommendedServings,
            displayOrder: response.displayOrder,
          });
          logEvent(events.pickMeals[TEMPO].boxRecommender.viewed, {
            mealPlanSlug: TEMPO,
            recommendedBoxSize: response.recommendedMeals,
          });
        } else {
          setWeeklyMeals(user.weeklyMeals);
          ErrorLogging.captureInfo(response.error);
        }
      } catch (error) {
        ErrorLogging.captureException(error.message);
      }
    };

    if (!user) return;

    fetchRecommendedBox();
  }, [user]);

  useEffect(() => {
    const fetchTieredPricingDetails = async user => {
      try {
        const response = await RequestService.getTieredPricingDetails({
          params: { id: user.mealPricePlan.id },
        });
        if (response.ok) {
          setMealPriceDetails(response.priceTiers);
        } else {
          ErrorLogging.captureException(response.error);
        }
      } catch (e) {
        ErrorLogging.captureException(e.message);
      }
    };

    fetchTieredPricingDetails(user);
  }, [user]);

  return (
    <div>
      {mealPriceDetails ? (
        <TempoBoxCustomizer
          weeklyMeals={weeklyMeals}
          setWeeklyMeals={setWeeklyMeals}
          boxRecommendations={boxRecommendations}
          mealPriceDetails={mealPriceDetails}
          isPickMeals={true}
          setShowBoxOptions={setShowBoxOptions}
        />
      ) : (
        <div className="grid grid-cols-2 gap-4">
          <Skeleton height={125} width={250} />
          <Skeleton height={125} width={250} />
          <Skeleton height={125} width={250} />
          <Skeleton height={125} width={250} />
        </div>
      )}
    </div>
  );
};

RecommendationsContainer.propTypes = {
  setWeeklyMeals: PropTypes.func,
  weeklyMeals: PropTypes.number,
  setShowBoxOptions: PropTypes.func,
};

export default RecommendationsContainer;
